import {
	CommencementBunkerValue,
	getCommencementBunkerValues as collapseBunkerParcels,
} from '@shared/utils/getCommencementBunkerValues';
import { EstimateBunker } from '@api/features/estimates/getEstimateDetails';
import { sortByFuelGrade } from '@client/screens/fleet/VoyageDetailsScreen/components/ItineraryTab/utils/helpers';

export type { CommencementBunkerValue };

export const getCommencementBunkerValues = (
	commencementBunkers: Array<EstimateBunker> | undefined,
): Array<CommencementBunkerValue> => {
	if (!commencementBunkers) {
		return [];
	}

	return collapseBunkerParcels(sortByFuelGrade(commencementBunkers));
};
